export default __webpack_public_path__ + "static/media/led.fabc5c7d.jpg";